import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b148b1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title font-normal text-white" }

import { ref, watch } from "vue";

//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'title1',
  props: {
    title: {
        required: true,
        type: String,
    },
    text: {
        required: true,
        type: String,
    },
    widthNum: {
        required: false,
        type: Number,
        default: 6
    }
},
  setup(__props) {

const props = __props;




//定义监听事件
//watch(
//  () => props.test,
//  (newVal: any) => {
//    //变更执行事件
//  }
//);

//定义回调事件
//const emit = defineEmits<{
//  (e: "resultTag", test: string): void;
//}>();

//定义生命周期事件
//onMounted(() => {
//  //生命周期处理内容
//});


// ---------------------数据变量定义-------------------------

//变量定义
//let test: any = ref<string>();



// ---------------------方法定义-------------------------

//const testMethon = function (item:string): string {
//  return "";
//};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("div", {
      class: "collspan text-white font-medium",
      style: _normalizeStyle({ maxWidth: _ctx.$px2rem(__props.widthNum * 16 + 'px')  })
    }, _toDisplayString(__props.text), 5)
  ]))
}
}

})